import { Mark } from 'tiptap'
// 支持上标
export default class SuperscriptMark extends Mark {
    get name() {
      return 'SuperscriptMark';
    }

    get schema() {
      return {
        parseDOM: [
          { 
            tag: 'sup',
          },
        ],
        toDOM: () => ['sup', 0],
      }
    }
  }
